<template>
  <footer>
    <p>
      &copy; {{ year }} Invision Services Limited. Registered in England
      No.13223149. All Rights Reserved.
    </p>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  computed: {
    year () {
      return new Date().getFullYear()
    }
  }
}
</script>
